import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as CollectionActions from './collection/collection.actions';
import * as CollectionSelectors from './collection/collection.selectors';
import { UsernameService } from './username.service';
import { Observable } from 'rxjs';
import { OrgTypes } from '@mode/shared/contract-common';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceCollectionFacade {
  workspaceCollections$: Observable<ReadonlyArray<OrgTypes.Collection>>;
  sidebarCollections$: Observable<ReadonlyArray<OrgTypes.Collection>>;
  isLoading$: Observable<boolean>;
  isComplete$: Observable<boolean>;
  error$: Observable<Error | null>;

  constructor(
    private store: Store,
    private usernameService: UsernameService
  ) {
    this.workspaceCollections$ = store.select(CollectionSelectors.selectCollections);
    this.sidebarCollections$ = store.select(CollectionSelectors.selectSidebarSortedCollections);
    this.isLoading$ = store.select(CollectionSelectors.selectCollectionsLoading);
    this.isComplete$ = store.select(CollectionSelectors.selectCollectionsComplete);
    this.error$ = store.select(CollectionSelectors.selectCollectionsError);
  }

  loadCollections() {
    const username = this.usernameService.getOrg();
    if (username) {
      this.store.dispatch(CollectionActions.loadCollections({ username }));
    }
  }
}
